import { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "../../context";
import ErrorModal from "../../components/ErrorModal/ErrorModal";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import moment from "moment";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import { EVENT } from "./eventConstants";
import { searchEventTickets } from "./searchEventTickets";
import { DatePicker } from "antd";

const EventTicketFilter = ({ setProducts, store }) => {
  let info = useContext(AppContext);
  const location = useLocation();
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  // set info.monument values from URL params or if those don't exist, from standard values
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const date = params.get("date")
      ? moment(params.get("date"))
      : EVENT.defaults.date;

    info.setEvent({
      ...info.event,
      date,
    });
  }, []);

  useEffect(() => {
    (async () => {
      const tickets = await searchEventTickets(store.id, info);
      setProducts(tickets);
    })();
  }, [info.event]);

  return (
    <>
      <div className="ahp-filter">
        {/* <DatePicker
          onChange={(value) => info.setEvent({ ...info.event, date: value })}
          bordered={false}
          allowClear
          value={info.event.date}
        /> */}
      </div>

      <ErrorModal
        text="Por favor defina as datas de estadia."
        isErrorVisible={isErrorVisible}
        setIsErrorVisible={setIsErrorVisible}
      />
    </>
  );
};

export default EventTicketFilter;
